var _circle, _path, _path2, _path3, _path4, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 216,
    viewBox: "0 0 240 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 129,
    r: 87,
    fill: "url(#paint0_linear_11556_73981)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.108 79.6877L207 76.2465L198.312 72.8843L194.776 63L191.328 72.6368L182 76.2465L191.532 79.9352L194.776 89L198.108 79.6877Z",
    fill: "#BDC3C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.768 57C119.538 55.6667 121.462 55.6667 122.232 57L190.215 174.75C190.985 176.083 190.023 177.75 188.483 177.75H52.517C50.9774 177.75 50.0152 176.083 50.785 174.75L118.768 57Z",
    fill: "#8E9EAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.768 55C119.538 53.6667 121.462 53.6667 122.232 55L190.215 172.75C190.985 174.083 190.023 175.75 188.483 175.75H52.517C50.9774 175.75 50.0152 174.083 50.785 172.75L118.768 55Z",
    fill: "#BDC3C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.776 91.182C115.744 90.0619 116.637 89.1337 117.758 89.124L122.584 89.0824C123.704 89.0727 124.614 89.9854 124.601 91.1059L124.005 141.678C123.992 142.767 123.111 143.645 122.023 143.655L119.26 143.678C118.172 143.688 117.276 142.825 117.244 141.737L115.776 91.182Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.719,
    cy: 152.575,
    r: 4.45432,
    transform: "rotate(-0.49411 120.719 152.575)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11556_73981",
    x1: 101,
    y1: -254,
    x2: 120,
    y2: 285.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.fe6fbdb19c5b5be1570a42608a6bd0b6.svg";
export { ForwardRef as ReactComponent };